<div class="row no-gutters full-width">
  <div class="col-sm-12">
    <mat-form-field class="full-width">
      <mat-label>{{ labelText }}</mat-label>
      <input id="{{idPrefix}}vehicle.vin"
             type="text"
             class="vin-input"
             matInput
             maxlength="{{maxLenght}}"
             [(ngModel)]="vin"
             [disabled]="disabled"
             (blur)="onChange('vehicle.vin', vin)"
             vin>
      <mat-hint align="end">{{vin ? vin.length : '0'}} / {{maxLenght}}</mat-hint>
    </mat-form-field>
  </div>
</div>
